// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T01:10:51.883Z
// Property: Bay Arms (ID: 6767906449167173)
// Collections: 13 amenities, 5 floorplans (live), 17 photos, 69 POIs, 3 reviews, 4 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167173",
  "property_external_id": "1101867",
  "property_zillow_url": "https://www.zillow.com/apartments/kenai-ak/bay-arms/Ck536W/",
  "property_apartments_url": "https://www.apartments.com/bay-arms-kenai-ak/he6bbx1/",
  "property_google_business_url": "https://www.google.com/maps/place/Bay+Arms+Apartment+Homes/data=!4m2!3m1!1s0x0:0x9f2c7edbb5d13a8?sa=X&ved=2ahUKEwi72-qS6IOTAxVQD1kFHej6MWIQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47573318947",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "bay-arms",
  "property_name": "Bay Arms",
  "property_website_url": "https://www.bayarmsapartments.com",
  "property_domain": "https://www.bayarmsapartments.com",
  "property_address": "514 Overland Ave",
  "property_full_address": "514 Overland Ave, Kenai, AK 99611",
  "property_address_1": "514 Overland Ave",
  "property_address_2": null,
  "property_address_city": "Kenai",
  "property_address_state": "AK",
  "property_address_zip_full": "99611",
  "property_address_zip": "99611",
  "property_address_country": "US",
  "property_address_county": "Kenai Peninsula Borough",
  "property_neighborhood_address": "Alaska Regional",
  "property_address_latitude": "60.5526325",
  "property_address_longitude": "-151.2677954",
  "property_email": "bayarms@weidner.com",
  "property_phone": "(907) 308-5037",
  "property_call_tracking_phone": "907-308-5037",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Bay Arms in picturesque Kenai, AK, your perfect home awaits. Choose from thoughtfully designed studio to three-bedroom floor plans, complemented by modern amenities like a waterfront courtyard, community garden, and large closets. Experience stress-free living with dedicated on-site management and 24-hour emergency maintenance. Secure your dream space today!",
  "property_long_description": "Welcome to Bay Arms, your ideal waterfront living destination in the heart of Kenai, AK. Our thoughtfully designed apartment community offers a variety of floor plans to suit your lifestyle, including cozy studios, spacious one, two, and three-bedroom apartments. Whether you’re looking for a peaceful retreat or a vibrant community, Bay Arms has the perfect home for you.\n\nAt Bay Arms, we prioritize your comfort and convenience with our exceptional amenities. Enjoy peace of mind with our 24-hour emergency maintenance and dedicated on-site management. For the outdoor enthusiasts, our picturesque community garden and beautifully landscaped courtyard provide perfect spots to unwind. Stay organized with large closets and well-equipped pantries in every unit, and take advantage of our convenient laundry facilities on-site.\n\nBreathe easy in our smoke-free environment while embracing the stunning waterfront views from select apartments. You’ll also appreciate additional features such as bike storage and private patios or balconies, perfect for enjoying the Alaskan scenery.\n\nDon’t miss out on the chance to make Bay Arms your new home! Explore our availability and see the difference for yourself. Schedule a tour today to experience the welcoming community and exceptional amenities that await you at Bay Arms. Your new adventure starts here!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021b-e608-7457-9fa1-7f554aed06a0.webp",
  "property_featured_image_media": {
    "alt_text": "Spacious living room with a sectional sofa, coffee table, and large sliding glass door.",
    "public_id": "019d021b-e608-7457-9fa1-7f554aed06a0",
    "storage_key": "property/6767906449167173/019d021b-e608-7457-9fa1-7f554aed06a0.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "54",
  "property_year_built": "1967",
  "property_year_renovated": null,
  "property_walk_score": "35",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,000",
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "0",
  "property_max_pets": "0",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "No pets allowed. Certified service dogs are allowed.",
  "property_pet_policy_description": "No pets allowed. Certified service dogs are allowed.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/bay-arms/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/bay-arms/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/bay-arms/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140df-bf63-74fb-8b0a-a90ac3fea062.webp",
  "property_primary_logo_media": {
    "alt_text": "Bay Arms Apartment Homes logo",
    "public_id": "01a140df-bf63-74fb-8b0a-a90ac3fea062",
    "storage_key": "property/6767906449167173/01a140df-bf63-74fb-8b0a-a90ac3fea062.webp",
    "width": 199,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140df-f485-71ab-9ac2-0a7b4f8b0318.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a140df-f485-71ab-9ac2-0a7b4f8b0318",
    "storage_key": "property/6767906449167173/01a140df-f485-71ab-9ac2-0a7b4f8b0318.webp",
    "width": 199,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140df-e8b7-734f-b426-9e943d23f330.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a140df-e8b7-734f-b426-9e943d23f330",
    "storage_key": "property/6767906449167173/01a140df-e8b7-734f-b426-9e943d23f330.webp",
    "width": 199,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#4A7FA5",
  "property_secondary_color": "#D4C5A9",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#1B2D4F",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - ",
  "property_sqft_min": "350",
  "property_sqft_max": "2080",
  "property_price_range": "665 - 1600",
  "property_price_min": "665",
  "property_price_max": "1600",
  "property_available_units": null,
  "property_facebook_url": "https://www.facebook.com/BayArmsApartments/",
  "property_instagram_url": "https://www.instagram.com/weidnerapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJXfKKAJB8xlYRqBNdu-3H8gk",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Bay Arms Apartments",
  "property_home_romance_title": "Welcome Home to Kenai Life",
  "property_home_amenities_blurb": "Welcome to Bay Arms in picturesque Kenai, AK! Choose from our thoughtfully designed studio to three-bedroom apartments, perfect for any lifestyle. Enjoy the serenity of waterfront views, spacious closets, and a vibrant community garden. Revel in 24-hour maintenance and smoke-free living. Elevate your home experience today!",
  "property_home_floorplans_blurb": "At Bay Arms in beautiful Kenai, AK, our thoughtfully designed apartment floor plans cater to your unique lifestyle. Enjoy spacious living areas and stunning views that enhance your everyday experience. Browse our available homes today and uncover the perfect space to call your own amid the breathtaking scenery of Alaska.",
  "property_home_gallery_blurb": "Welcome to Bay Arms in beautiful Kenai, AK, where versatility meets comfort! Choose from spacious floor plans—studio to three-bedroom—and enjoy exceptional amenities like a community garden, waterfront views, and 24-hour maintenance. Immerse yourself in a smoke-free lifestyle and picture your future in this inviting community!",
  "property_home_neighborhood_blurb": "<p>Living at Bay Arms places you in the heart of Old Town Kenai, with easy access to the Kenai Spur Highway for straightforward commutes. You're near Walmart, Kenai International Airport, and Three Bears - so errands and travel are always within reach. Whether strolling along Kenai Beach or relaxing at Old Town Kenai Park, adventures and everyday conveniences are right outside your door.</p>",
  "property_home_reviews_blurb": "Welcome to Bay Arms, where our residents celebrate the unique charm of Kenai, AK! With rave reviews like “a peaceful haven with stunning views,” our welcoming community is designed for comfort and connection. See what our residents have to say about living at our community and discover your next home!",
  "property_neighborhood_blurb": "<p>At Bay Arms in Kenai, AK, everyday tasks become easy and weekends offer endless possibilities. Located near Kenai Spur Highway, you're minutes from Kenai Plaza and Old Kenai Mall for shopping. Enjoy your morning coffee from Shorty's Coffee before heading to nearby employers or exploring Old Town Kenai Park. With Kenai Beach close by, waterfront relaxation is always an option. Discover a place where life moves at your pace, and everything you need is within reach.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Bay Arms, experience comfort and daily ease at home and throughout the community in Kenai, AK. Each apartment offers plenty of storage, including large closets and a pantry, plus a private patio or balcony. Enjoy conveniences like a laundry room, bike storage, a courtyard, and fresh air along the waterfront. Take time to grow in the community garden or unwind, knowing on-site management and emergency maintenance are here when you need them.</p>",
  "property_applynow_blurb": "At Bay Arms in Kenai, AK, choose from a variety of thoughtfully designed floor plans, including cozy studios and spacious three-bedrooms. Enjoy amenities like waterfront views, a community garden, and 24-hour maintenance. Elevate your living experience—apply online now and make Bay Arms your new home!",
  "property_contactus_blurb": "<p>Want to know more about Bay Arms? Contact our team in Kenai, AK, for details or to arrange a tour. Our leasing professionals are ready to help you discover floor plans and community comforts that suit your routine.</p>",
  "property_faqs_blurb": "At Bay Arms in Kenai, AK, we offer a range of thoughtfully designed floor plans, from cozy studios to spacious three-bedroom apartments. Have questions? Our FAQs page is here to provide the insights you need about our vibrant community and resident life. Dive in and get informed today!",
  "property_floorplans_blurb": "<p>Bay Arms offers a variety of apartment floor plans for rent in Kenai, AK. Choose from cozy studios to spacious three-bedroom homes, each with ample closet space and a private patio or balcony to enjoy the crisp Alaskan air. With thoughtful layouts, you can create a relaxing retreat, dedicated workspace, or gathering spot. Every home comes standard with comfort and convenience.</p>",
  "property_gallery_blurb": "<p>Picture the easygoing Kenai lifestyle at Bay Arms through our photo gallery. See bright living spaces with oversized windows, private patios, and modern touches - all framed by breathtaking Alaskan scenery. Preview open kitchens, tranquil bedrooms, and community spaces like the garden and waterfront. Imagine how you'll unwind and create memories in your new home.</p>",
  "property_interactivemap_blurb": "Welcome to Bay Arms in picturesque Kenai, AK, where comfort meets convenience. Choose from spacious studios to elegant three-bedroom layouts, all featuring modern amenities like large closets and waterfront views. Our interactive community map makes it easy to find your perfect home, tailored just for you.",
  "property_pets_blurb": "Nestled in the heart of Kenai, AK, Bay Arms offers a serene oasis for residents seeking comfort and tranquility. Enjoy spacious living with stunning views and modern amenities, all within walking distance to local attractions. Please note, we uphold a no-pet policy, allowing only certified service dogs for relaxation and peace.",
  "property_referafriend_blurb": "At Bay Arms in Kenai, AK, our diverse floor plans—ranging from cozy studios to spacious three-bedrooms—perfectly suit your lifestyle. Great friends make great neighbors, so refer a friend to join our vibrant community today and experience the perfect blend of comfort and camaraderie!",
  "property_residentaccess_blurb": "Welcome to Bay Arms in Kenai, AK, where comfort meets convenience. Choose from thoughtfully designed studio to three-bedroom floor plans, perfect for any lifestyle. Access your resident portal to effortlessly manage rent payments, schedule maintenance, and more, enhancing your living experience with just a few clicks.",
  "property_reviews_blurb": "At Bay Arms in Kenai, AK, our residents rave about the vibrant community atmosphere, with one noting, “The friendly neighbors make every day feel like home.” Dive into the heartfelt experiences shared by our residents and see why Bay Arms is the perfect place to call home!",
  "property_created_at": "1771535857814",
  "property_scheduletour_blurb": "<p>Ready to see Bay Arms for yourself? Schedule a tour to see our studio, one-, two-, and three-bedroom apartments in Kenai, AK. Explore roomy closets, a relaxing patio or balcony, and inviting community features like the garden and courtyard. Meet our leasing team, ask questions, and start picturing your life here. Touring restrictions may apply.</p>",
  "property_thankyou_blurb": "Thank you for reaching out! At Bay Arms in Kenai, AK, we offer diverse floor plans tailored to your lifestyle, including studios and spacious three-bedroom options. Our team is excited to assist you in finding your perfect home. Stay tuned for our expert guidance—your new adventure awaits!",
  "property_virtualtours_blurb": "<p>Step inside Bay Arms in Kenai, AK, without leaving your favorite chair. Our virtual tour makes it easy to get a sense of the lifestyle, the layouts, and the welcoming feel of our community. Picture mornings on your patio or evenings enjoying Kenai's vast views - all from wherever you are. It's a simple way to start imagining what living here can look like for you.</p>",
  "property_copyright": "2026 All Rights Reserved. Bay Arms",
  "property_seo_title_home": "Comfortable Apartments | Bay Arms | Kenai, AK",
  "property_seo_description_home": "Enjoy relaxed living near Kenai Beach with on-site perks at Bay Arms apartments in Kenai, AK.",
  "property_seo_title_floorplans": "Floor Plans | Bay Arms | Kenai, AK",
  "property_seo_description_floorplans": "Find your ideal studio, one-, two-, or three-bedroom layout at Bay Arms in Kenai, AK, with large closets and private patios.",
  "property_seo_title_amenities": "Amenities | Bay Arms | Kenai, AK",
  "property_seo_description_amenities": "Explore community and in-home amenities, including waterfront views, a patio/balcony, and a community garden, at Bay Arms in Kenai, AK.",
  "property_seo_title_gallery": "Photo Gallery | Bay Arms | Kenai, AK",
  "property_seo_description_gallery": "Browse inviting interiors, scenic views, and community spaces at Bay Arms Apartments in Kenai, AK. See life in this coastal community.",
  "property_seo_title_virtualtours": "Virtual Tour | Bay Arms | Kenai, AK",
  "property_seo_description_virtualtours": "Take a virtual tour of Bay Arms in Kenai, AK, and see the inviting lifestyle and comfortable layouts from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Bay Arms Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Bay Arms in Kenai, AK! Browse our interactive community map to uncover studio to three-bedroom layouts and stunning waterfront views.",
  "property_seo_title_neighborhood": "Old Town Kenai | Bay Arms | Kenai, AK",
  "property_seo_description_neighborhood": "Live at Bay Arms in Kenai, AK, near Kenai Plaza, Old Town Kenai Park, Kenai Beach, and dining, for convenience and local flavor.",
  "property_seo_title_contact": "Contact Bay Arms Apartments | Kenai, AK",
  "property_seo_description_contact": "Contact Bay Arms in Kenai, AK, and our leasing team will help you explore your next apartment home. We look forward to connecting.",
  "property_seo_title_faqs": "FAQs | Apartments in Kenai, AK",
  "property_seo_description_faqs": "Find answers to your questions about life at Bay Arms in Kenai, AK. From floor plans to amenities, we’ve got all the details for your ideal waterfront home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kenai, AK",
  "property_seo_description_reviews": "Experience the charm of Bay Arms in Kenai, AK. Read resident reviews and see why our spacious layouts and vibrant amenities make home feel special!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kenai, AK",
  "property_seo_description_applynow": "Discover your home at Bay Arms, Kenai, AK! Choose from studios to three-bedroom apartments with waterfront views and a community garden. Lease now!",
  "property_seo_title_residentaccess": "Resident Access | Bay Arms",
  "property_seo_description_residentaccess": "Unlock a seamless living experience at Bay Arms in Kenai, AK. Access your resident portal to pay rent, request maintenance, and enjoy your community!",
  "property_seo_title_referafriend": "Refer A Friend | Bay Arms",
  "property_seo_description_referafriend": "Refer a friend to Bay Arms in Kenai, AK! Share the joy of comfortable living and create a thriving community together. Great friends make great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Bay Arms | Kenai, AK",
  "property_seo_description_scheduletour": "Schedule a tour of Bay Arms in Kenai, AK, to explore studio, one-, two-, and three-bedroom options and welcoming community spaces.",
  "property_seo_title_privacy": "Privacy Policy | Bay Arms",
  "property_seo_description_privacy": "At Bay Arms in Kenai, AK, we prioritize your privacy. Learn how we protect your information while you enjoy the comforts of our vibrant apartment community.",
  "property_seo_title_accessibility": "Website Accessibility | Bay Arms",
  "property_seo_description_accessibility": "At Bay Arms in Kenai, AK, we prioritize accessibility for all. Join our community that embraces inclusivity and ensures everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Bay Arms",
  "property_seo_description_sitemap": "Navigate your way through Bay Arms in Kenai, AK! Check out our sitemap for the latest community amenities, floor plans, and updates. Your next home awaits!",
  "property_seo_title_thankyou": "Thank You | Bay Arms",
  "property_seo_description_thankyou": "Thank you for reaching out to Bay Arms in Kenai, AK! We’ll connect soon to help you find your perfect home in our vibrant community. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Kenai, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764136",
  "amenities": [
    {
      "id": "ec_8b6cb953fac9027a0c3e9f08",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452402",
      "title": "Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e36626550045d4c366ae31fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452404",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_914035fc917887ade3f247e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452405",
      "title": "Laundry Room/Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d9a33-9a17-76da-b06e-2234b7e1e293.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with multiple washers and dryers.",
        "public_id": "019d9a33-9a17-76da-b06e-2234b7e1e293",
        "storage_key": "property/6767906449167173/019d9a33-9a17-76da-b06e-2234b7e1e293.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Bay Arms Apartments - Laundry Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc2397e337c037d258b259fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452421",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4081924256ff5d777c65cc3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452422",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0e254e1904fe055a0960ef4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452428",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7bacaa94a6656ece577f9b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452430",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9b5dceb4658901727cf65a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452431",
      "title": "View*",
      "amount": "false",
      "description": "Ocean Views",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c910de8a1ed191b400b5998",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452426",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_395bf6c7ff9c12c269a716f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452403",
      "title": "Community Garden",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f38c1b2bf1049296f65c509c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452429",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16faf61094b3cc8aac1e5873",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "124799802",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4c15eaac281a67c2e8b5e6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "87452424",
      "title": "Waterfront",
      "amount": "false",
      "description": "5 Minute Walk From Ocean",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_fa118e6b3c7455ef1e7fe875",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021b-e608-7457-9fa1-7f554aed06a0.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d021b-e608-7457-9fa1-7f554aed06a0",
        "storage_key": "property/6767906449167173/019d021b-e608-7457-9fa1-7f554aed06a0.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring a comfortable sectional sofa, a modern coffee table, and ample natural light streaming in from the sliding glass doors.",
      "link": "false",
      "alt_text": "A bright living room at Bay Arms Apartments with a large sectional sofa, a wooden coffee table, and neutral décor. A sliding glass door opens to a grassy outdoor area and lets in natural light. Soft carpet and a hallway leading to the bedrooms create a comfortable open layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(1).jpg"
    },
    {
      "id": "ec_67863d0e830c84f25dec6c66",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021b-e79e-7626-87cb-2766768e982f.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, coffee maker, sink, white stove, and microwave.",
        "public_id": "019d021b-e79e-7626-87cb-2766768e982f",
        "storage_key": "property/6767906449167173/019d021b-e79e-7626-87cb-2766768e982f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring dark wood cabinetry, a white refrigerator, stove, and microwave, perfect for preparing meals.",
      "link": "false",
      "alt_text": "A bright kitchen at Bay Arms Apartments featuring wood cabinets, white countertops, and a double sink beneath a window. The space includes a refrigerator, stovetop and oven, microwave, and coffee maker. Neutral flooring and simple décor create a clean and functional cooking area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(2).jpg"
    },
    {
      "id": "ec_f4c38a49d4f6b123571cd447",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021b-e71b-7357-a5e2-28009dd954f9.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-size bed, nightstands, dresser, and window.",
        "public_id": "019d021b-e71b-7357-a5e2-28009dd954f9",
        "storage_key": "property/6767906449167173/019d021b-e71b-7357-a5e2-28009dd954f9.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax and unwind in the spacious bedroom, featuring a comfortable queen-size bed, ample storage, and a large window with scenic views.",
      "link": "false",
      "alt_text": "A serene bedroom at Bay Arms Apartments with a cozy bed dressed in white bedding and neutral pillows. Two bedside tables with lamps frame the bed, and a dresser sits to the side with décor. A window with vertical blinds brings in natural light, brightening the carpeted space and soft area rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(3).jpg"
    },
    {
      "id": "ec_f1a8e6e34b4a2563c4a7b393",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021b-e9b0-72a3-9de1-e60e13974d0f.webp",
      "image_media": {
        "alt_text": "Bathroom with a sink, toilet, and a shower curtain with an elephant print.",
        "public_id": "019d021b-e9b0-72a3-9de1-e60e13974d0f",
        "storage_key": "property/6767906449167173/019d021b-e9b0-72a3-9de1-e60e13974d0f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a clean white sink and toilet, complemented by a decorative shower curtain with a unique elephant pattern.",
      "link": "false",
      "alt_text": "A cozy bathroom at Bay Arms Apartments with a vanity and sink, a wide mirror, and a shower and bathtub combo. A patterned curtain with an elephant design adds color and personality. The room includes a toilet, towel rack, and neutral walls, creating a clean and welcoming space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(4).jpg"
    },
    {
      "id": "ec_938afcbbee36d5ad28327d4b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021b-f412-700c-8467-70dd08b4711c.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower with decorative curtain.",
        "public_id": "019d021b-f412-700c-8467-70dd08b4711c",
        "storage_key": "property/6767906449167173/019d021b-f412-700c-8467-70dd08b4711c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a vanity with a sink and mirror, a toilet, and a shower with a decorative curtain.",
      "link": "false",
      "alt_text": "A stylish bathroom at Bay Arms Apartments featuring a vanity with sink and wood-framed mirror cabinet. A shower and bathtub combo sits behind a patterned curtain in neutral and teal tones. Soft lighting, a toilet, and towel racks complete this bright and functional space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(5).jpg"
    },
    {
      "id": "ec_82672b99b5484ce3f4cb2e81",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021b-f75c-75af-92b1-3e4bad872449.webp",
      "image_media": {
        "alt_text": "Spacious living room with sliding glass doors and a view of the outdoors.",
        "public_id": "019d021b-f75c-75af-92b1-3e4bad872449",
        "storage_key": "property/6767906449167173/019d021b-f75c-75af-92b1-3e4bad872449.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the natural light in this expansive living area, featuring large sliding glass doors that open to the outdoors. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "A spacious living room at Bay Arms Apartments with plush carpet and neutral walls. A large sliding glass door opens to a grassy outdoor area and fills the space with natural light. A hallway leads to the bedrooms and bathroom, offering an open and functional layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(6).jpg"
    },
    {
      "id": "ec_a2a82b7af48873626d8bf2ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021b-ff9c-75f2-8fcb-1e0abe6df1c5.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets and white countertops, adjacent to a living area with a sliding glass door.",
        "public_id": "019d021b-ff9c-75f2-8fcb-1e0abe6df1c5",
        "storage_key": "property/6767906449167173/019d021b-ff9c-75f2-8fcb-1e0abe6df1c5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment features a functional kitchen with ample cabinet space and a clean, spacious living area that opens to the outdoors.",
      "link": "false",
      "alt_text": "A bright open layout at Bay Arms Apartments showing a spacious living room with plush carpet and a sliding glass door that opens to a grassy outdoor area. The adjoining kitchen features wood cabinets, countertops, and a stovetop, creating a practical cooking and dining flow.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(7).jpg"
    },
    {
      "id": "ec_26190fc5f389912e2a4c4305",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-028f-71cf-bdf5-e5a89c9d61a7.webp",
      "image_media": {
        "alt_text": "Living area and kitchen with wood cabinets and white countertops.",
        "public_id": "019d021c-028f-71cf-bdf5-e5a89c9d61a7",
        "storage_key": "property/6767906449167173/019d021c-028f-71cf-bdf5-e5a89c9d61a7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting opens up to a functional kitchen featuring ample wood cabinetry and white countertops. A hallway leads to closet space.",
      "link": "false",
      "alt_text": "A spacious living area at Bay Arms Apartments with plush carpet and neutral walls. The open layout leads into the kitchen, which features wood cabinets and a long countertop. A hallway and closet space sit nearby, offering functional storage and room flexibility.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(8).jpg"
    },
    {
      "id": "ec_85e3eae3e3125dcc3305769d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-0a73-7200-a912-830ac9c06c43.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, white countertop, white refrigerator, and stove.",
        "public_id": "019d021c-0a73-7200-a912-830ac9c06c43",
        "storage_key": "property/6767906449167173/019d021c-0a73-7200-a912-830ac9c06c43.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, a white countertop, a double sink, a white refrigerator, and a stove.",
      "link": "false",
      "alt_text": "A spacious kitchen at Bay Arms Apartments featuring wood cabinets, long countertops, a double sink, and a stovetop. A large refrigerator sits near a bright window with blinds that bring in natural light. Neutral flooring and ample storage make the space functional and convenient.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(9).jpg"
    },
    {
      "id": "ec_7424039a67b8cb46f1bc14e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-11f3-712e-8c5c-9108338d645a.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet and a large window with vertical blinds.",
        "public_id": "019d021c-11f3-712e-8c5c-9108338d645a",
        "storage_key": "property/6767906449167173/019d021c-11f3-712e-8c5c-9108338d645a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and neutral bedroom, ready for your personal touch. Features plush carpeting and a large window for natural light.",
      "link": "false",
      "alt_text": "A bright bedroom at Bay Arms Apartments with plush carpet, neutral walls, and a large window with vertical blinds. Sunlight fills the space, highlighting the open layout and baseboard heating. The room offers plenty of flexibility for furniture placement.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(10).jpg"
    },
    {
      "id": "ec_800ea884f154586e1a001e42",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-11e1-719b-b6a7-4cde9948f803.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a large closet and a door.",
        "public_id": "019d021c-11e1-719b-b6a7-4cde9948f803",
        "storage_key": "property/6767906449167173/019d021c-11e1-719b-b6a7-4cde9948f803.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "An empty bedroom featuring a spacious closet with sliding wooden doors and a beige carpeted floor. A second door is visible in the background.",
      "link": "false",
      "alt_text": "A clean bedroom at Bay Arms Apartments with plush carpet and neutral walls. A large closet with sliding wood doors provides storage space, and a doorway leads to the hallway. The room’s simple layout offers plenty of flexibility for bedroom furnishings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(11).jpg"
    },
    {
      "id": "ec_03f3219ba4277caeff1e9be4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-1808-754e-8b03-c28bd899f290.webp",
      "image_media": {
        "alt_text": "Laundry room with washers and dryers",
        "public_id": "019d021c-1808-754e-8b03-c28bd899f290",
        "storage_key": "property/6767906449167173/019d021c-1808-754e-8b03-c28bd899f290.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities for residents.",
      "link": "false",
      "alt_text": "A clean laundry room at Bay Arms Apartments featuring two top-loading washing machines and a stacked dryer set. A long folding counter provides workspace, and neutral walls and flooring create a bright, practical environment for everyday laundry needs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(12).jpg"
    },
    {
      "id": "ec_66b850fe37fcc7a35a0e713d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-18c9-75eb-8f72-4575d5ad77d7.webp",
      "image_media": {
        "alt_text": "Office space with desk, chairs, and couch overlooking the ocean.",
        "public_id": "019d021c-18c9-75eb-8f72-4575d5ad77d7",
        "storage_key": "property/6767906449167173/019d021c-18c9-75eb-8f72-4575d5ad77d7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Work from home in style with this spacious office featuring a large desk, comfortable seating, and breathtaking ocean views.",
      "link": "false",
      "alt_text": "A welcoming leasing office at Bay Arms Apartments with a desk and chairs, a leather sofa, and décor. A large sliding glass door offers a stunning view of the water and grassy outdoor space, filling the room with natural light. Soft carpet and neutral walls create a comfortable environment for residents and guests.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(13).jpg"
    },
    {
      "id": "ec_7b168d30a127fb9137bcbda2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a037a0-f793-722d-a217-5ced0d570cfb.webp",
      "image_media": {
        "alt_text": "Exterior view of a red apartment building with a raised garden bed in the foreground and a scenic water view in the background.",
        "public_id": "01a037a0-f793-722d-a217-5ced0d570cfb",
        "storage_key": "property/6767906449167173/01a037a0-f793-722d-a217-5ced0d570cfb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful exterior view of the apartment building, featuring a lush green lawn, a raised garden bed, and a stunning water vista.",
      "link": "false",
      "alt_text": "A scenic exterior view of Bay Arms Apartments featuring a two-story red building with balconies and white trim. A wide grassy lawn stretches across the property with a raised planting bed in the center. The ocean sits just beyond the grounds, offering peaceful waterfront views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(20).jpg"
    },
    {
      "id": "ec_4db290477da10b0ab455fcf5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a037a0-f536-71ca-b924-2571b0a88d8f.webp",
      "image_media": {
        "alt_text": "Exterior of red apartment building with ocean view",
        "public_id": "01a037a0-f536-71ca-b924-2571b0a88d8f",
        "storage_key": "property/6767906449167173/01a037a0-f536-71ca-b924-2571b0a88d8f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming red apartment building with convenient parking and a scenic ocean view, offering a peaceful coastal living experience.",
      "link": "false",
      "alt_text": "A bright exterior view of Bay Arms Apartments showing part of a red two-story building with white trim and private entrances. A wide grassy lawn stretches out beside the parking area, leading to stunning ocean views and a clear blue sky in the distance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(21).jpg"
    },
    {
      "id": "ec_95768a92833044cc9dbf9825",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a037a0-f7ec-7110-9ba1-569272c2d73a.webp",
      "image_media": {
        "alt_text": "Scenic view of mountains and ocean from a property with a lamppost and green gate.",
        "public_id": "01a037a0-f7ec-7110-9ba1-569272c2d73a",
        "storage_key": "property/6767906449167173/01a037a0-f7ec-7110-9ba1-569272c2d73a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy breathtaking views of snow-capped mountains and the serene ocean from this beautiful community. Features include scenic landscaping and an elegant lamppost.",
      "link": "false",
      "alt_text": "A breathtaking oceanfront view at Bay Arms Apartments with lush green lawn, a lamp post, and distant mountains rising over the water. A cargo ship is visible on the horizon, and the clear blue sky adds to the peaceful coastal setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(18).jpg"
    },
    {
      "id": "ec_e4686edb77f38ca7086198d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a037a0-f545-723f-99fc-6f2ee72f0d35.webp",
      "image_media": {
        "alt_text": "Snow-capped mountains visible across a body of water, with a grassy field in the foreground.",
        "public_id": "01a037a0-f545-723f-99fc-6f2ee72f0d35",
        "storage_key": "property/6767906449167173/01a037a0-f545-723f-99fc-6f2ee72f0d35.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy breathtaking views of majestic snow-capped mountains from your new home. This stunning landscape offers a serene and picturesque backdrop to everyday life.",
      "link": "false",
      "alt_text": "A stunning waterfront view at Bay Arms Apartments overlooking calm ocean water and a sweeping mountain range in the distance. Bright blue skies and green shoreline vegetation create a peaceful, scenic backdrop just steps from the community.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Bay-Arms_Favorites%20(19).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1541d84f-f188-4ee4-805e-dfe29a9412cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Burger Bus",
      "poi_type": "Restaurants",
      "poi_address": "409 Overland Ave, Kenai, AK 99611, USA",
      "poi_short_description": "Casual bus-based eatery serving signature burgers and fries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-540e-75b7-9268-6632a988f10c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-540e-75b7-9268-6632a988f10c",
        "storage_key": "property/6767906449167173/019d021c-540e-75b7-9268-6632a988f10c.webp",
        "width": 1280,
        "height": 952
      },
      "poi_business_url": "https://m.facebook.com/kenaiburgerbus/?tsid=0.5965751575323619",
      "poi_directions_map_url": "https://maps.google.com/?cid=136477414787423972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burger-bus",
      "poi_latitude": "60.5537436",
      "poi_longitude": "-151.2621507",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-283-9611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQOmj5p8xlYR5J5EVHzd5AE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_82702c7c-dae6-4800-8cbb-ccc6618f750a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Veronica's Old Town Cafe",
      "poi_type": "Restaurants",
      "poi_address": "604 Petersen Way, Kenai, AK 99611, USA",
      "poi_short_description": "Casual cafe featuring gluten-free breads and hearty meal options like sandwiches, salads and soups.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e3-4b85-71bf-aa46-3c8f663e28e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e3-4b85-71bf-aa46-3c8f663e28e6",
        "storage_key": "property/6767906449167173/01a140e3-4b85-71bf-aa46-3c8f663e28e6.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6528450849382132097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veronicas-old-town-cafe",
      "poi_latitude": "60.5534158",
      "poi_longitude": "-151.2688828",
      "poi_miles_from_property": "0.08",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-283-2725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6yCWYV8xlYRgekEU3W3mVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2703cbbb-0ee1-4f71-96dd-be2b6addf0c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "The Espresso Barn",
      "poi_type": "Restaurants",
      "poi_address": "250 S Willow St, Kenai, AK 99611, USA",
      "poi_short_description": "Convenient drive-thru coffee shop serving locally roasted coffee and specialty beverages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-de39-7648-a3f0-d284f3cc73ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-de39-7648-a3f0-d284f3cc73ab",
        "storage_key": "property/6767906449167173/01a140e4-de39-7648-a3f0-d284f3cc73ab.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://order.joe.coffee/the-espresso-barn",
      "poi_directions_map_url": "https://maps.google.com/?cid=612774503347762952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-espresso-barn",
      "poi_latitude": "60.55636",
      "poi_longitude": "-151.2518383",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-283-6565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c638-775a-ba19-d9163000b17c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c638-775a-ba19-d9163000b17c",
        "storage_key": "property/6767906449167173/019d021c-c638-775a-ba19-d9163000b17c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJVcHaEpx8xlYRCLd1ByoDgQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_8cd67db5-e816-4f38-a47f-9485192b0397",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Brothers' Cafe",
      "poi_type": "Restaurants",
      "poi_address": "305 N Willow St, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-db1a-70cb-9aaf-1aff15b9dcf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-db1a-70cb-9aaf-1aff15b9dcf6",
        "storage_key": "property/6767906449167173/01a140e4-db1a-70cb-9aaf-1aff15b9dcf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kenaibrothers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5583593772354698220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brothers-cafe",
      "poi_latitude": "60.5648583",
      "poi_longitude": "-151.2472146",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-335-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c638-775a-ba19-d9163000b17c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c638-775a-ba19-d9163000b17c",
        "storage_key": "property/6767906449167173/019d021c-c638-775a-ba19-d9163000b17c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJdyp91YR7xlYR7PtI6_PofE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_fc5956aa-4f97-49f4-ae0a-66d3fda2806b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Jersey Subs - Kenai",
      "poi_type": "Restaurants",
      "poi_address": "305 N Willow St Ste 100, Kenai, AK 99611, USA",
      "poi_short_description": "Family-friendly sandwich shop serving large subs and Philly cheesesteaks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-d801-765e-ac6f-04492b4c20ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-d801-765e-ac6f-04492b4c20ca",
        "storage_key": "property/6767906449167173/01a140e4-d801-765e-ac6f-04492b4c20ca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clover.com/online-ordering/jersey-subs-kenai-kenai",
      "poi_directions_map_url": "https://maps.google.com/?cid=1045025514692446669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jersey-subs---kenai",
      "poi_latitude": "60.564846900000006",
      "poi_longitude": "-151.2472435",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-231-6335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVEoU5x8xlYRzYl2OCutgA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_79aa6a59-20c4-47ab-ba29-aab3082c778f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "B & H Pizza",
      "poi_type": "Restaurants",
      "poi_address": "10544 Kenai Spur Hwy C, Kenai, AK 99611, USA",
      "poi_short_description": "Local pizza restaurant offering delivery and quick lunch slices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-609e-72ba-bc8d-44e0f7706a61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-609e-72ba-bc8d-44e0f7706a61",
        "storage_key": "property/6767906449167173/019d021c-609e-72ba-bc8d-44e0f7706a61.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.bhpizza907.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9952296592336763173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "b--h-pizza",
      "poi_latitude": "60.55977009999999",
      "poi_longitude": "-151.2380672",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-335-0307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0owLGB7xlYRJTmQbQWpHYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_bcdf932b-463a-44d2-8767-91e4e596cd70",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Samurai Sam's",
      "poi_type": "Restaurants",
      "poi_address": "10544 Kenai Spur Hwy Ste 4, Kenai, AK 99611, USA",
      "poi_short_description": "Japanese chain restaurant offering stir-fried teriyaki bowls & other made-to-order staples.",
      "poi_long_description": "Japanese chain restaurant offering stir-fried teriyaki bowls & other made-to-order staples.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-d926-7645-b4c1-bc989e40e7e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-d926-7645-b4c1-bc989e40e7e9",
        "storage_key": "property/6767906449167173/01a140e4-d926-7645-b4c1-bc989e40e7e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.samuraisams.net/stores/5177",
      "poi_directions_map_url": "https://maps.google.com/?cid=9265591149303743300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "samurai-sams",
      "poi_latitude": "60.55990380000001",
      "poi_longitude": "-151.2378767",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-0233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30zTF4t7xlYRRMNAIA_-lYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_95c8c998-9d7b-4ca7-a34d-b00f40c5e82e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "New Peking Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "145 S Willow St, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-d944-764a-9bd9-74b3aeff8b4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-d944-764a-9bd9-74b3aeff8b4c",
        "storage_key": "property/6767906449167173/01a140e4-d944-764a-9bd9-74b3aeff8b4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.site.naver.com/qrcode/view.nhn?v=0QaJ1",
      "poi_directions_map_url": "https://maps.google.com/?cid=10840349602122762906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-peking-restaurant",
      "poi_latitude": "60.5575309",
      "poi_longitude": "-151.2509459",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4oxFZx8xlYRmgqTS4eocJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_bc959f0f-310e-4902-8184-2c2727f94c8c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Los Compadres Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10672 Kenai Spur Hwy #108, Kenai, AK 99611, USA",
      "poi_short_description": "Authentic Mexican restaurant featuring generous portions and a signature salsa bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-d73f-748b-980a-5db3fb03a3b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-d73f-748b-980a-5db3fb03a3b3",
        "storage_key": "property/6767906449167173/01a140e4-d73f-748b-980a-5db3fb03a3b3.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://loscompadresmexicanrestaurantak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18186380721107993112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-compadres-mexican-restaurant",
      "poi_latitude": "60.55884119999999",
      "poi_longitude": "-151.2410119",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7XtbXv19xlYRGIKnB-kAY_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b7fcfa10-fa98-442e-af95-afd70aaf1c64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Playa Azul | Mexican",
      "poi_type": "Restaurants",
      "poi_address": "12498 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "Casual Mexican eatery featuring a popular salsa bar and hearty portions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-dd20-726d-ba27-eac598a5f585.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-dd20-726d-ba27-eac598a5f585",
        "storage_key": "property/6767906449167173/01a140e4-dd20-726d-ba27-eac598a5f585.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://yohoho3.org/playa-azul",
      "poi_directions_map_url": "https://maps.google.com/?cid=11002580982099859008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "playa-azul--mexican",
      "poi_latitude": "60.56145360000001",
      "poi_longitude": "-151.2862669",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-2010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuzlUr318xlYRQNaH6hsFsZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_26ace7b1-595e-4b55-83de-5de68ea4d011",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Louie's Steak & Seafood",
      "poi_type": "Restaurants",
      "poi_address": "47 Spur View Dr, Kenai, AK 99611, USA",
      "poi_short_description": "Alaskan-themed restaurant serving large portions of steak and seafood.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e3-50b4-739a-b73a-9283d3ee5b31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e3-50b4-739a-b73a-9283d3ee5b31",
        "storage_key": "property/6767906449167173/01a140e3-50b4-739a-b73a-9283d3ee5b31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.louiessteakandseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13583534223880537754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "louies-steak--seafood",
      "poi_latitude": "60.55583329999999",
      "poi_longitude": "-151.2438889",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-3660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQRXv2J58xlYRmsbCcGhogrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4583b58a-5db9-46c2-a225-bd5334cb20b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "The Flats Bistro",
      "poi_type": "Restaurants",
      "poi_address": "39847 Kalifornsky Beach Rd, Kenai, AK 99611, USA",
      "poi_short_description": "Upscale Alaskan restaurant featuring scenic views and a diverse menu of gourmet dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e3-503f-7329-a12e-2167a2820a67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e3-503f-7329-a12e-2167a2820a67",
        "storage_key": "property/6767906449167173/01a140e3-503f-7329-a12e-2167a2820a67.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.theflatsbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371375784887923838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-flats-bistro",
      "poi_latitude": "60.5163612",
      "poi_longitude": "-151.21794119999998",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-335-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxrB1S9jxlYRfjTF9ISsa1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cdc28bd1-f1c9-4f3a-abab-32837adddc32",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Paradiso's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "815 Main St, Kenai, AK 99611, USA",
      "poi_short_description": "Specializing in Greek food, this spot also offers Mexican & Italian dishes, plus steak & seafood.",
      "poi_long_description": "Specializing in Greek food, this spot also offers Mexican & Italian dishes, plus steak & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-deb7-741d-a468-27c4b0b2b96d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-deb7-741d-a468-27c4b0b2b96d",
        "storage_key": "property/6767906449167173/01a140e4-deb7-741d-a468-27c4b0b2b96d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pizzaparadisos.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=9223406892134995011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paradisos-restaurant",
      "poi_latitude": "60.551870400000006",
      "poi_longitude": "-151.2598244",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-283-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c634-7016-bde4-759f5fb94bdb",
        "storage_key": "property/6767906449167173/019d021c-c634-7016-bde4-759f5fb94bdb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw3K5-Zp8xlYRQ5SYYLMfAIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_2ff9b1b1-e1da-4f30-be6e-3fe17c9f670e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Quality Inn Kenai",
      "poi_type": "Restaurants",
      "poi_address": "10352 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "Unassuming lodging with simple rooms, plus an indoor pool, free hot breakfast buffet and WiFi.",
      "poi_long_description": "Unassuming lodging with simple rooms, plus an indoor pool, free hot breakfast buffet and WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-da06-768a-b795-13b66631bf19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-da06-768a-b795-13b66631bf19",
        "storage_key": "property/6767906449167173/01a140e4-da06-768a-b795-13b66631bf19.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.choicehotels.com/alaska/kenai/quality-inn-hotels/ak032?mc=llgoxxpx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10924903372959803160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quality-inn-kenai",
      "poi_latitude": "60.561938000000005",
      "poi_longitude": "-151.23315789999998",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-621-5838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0df4-753a-82e3-4d247263fdd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140e5-0df4-753a-82e3-4d247263fdd3",
        "storage_key": "property/6767906449167173/01a140e5-0df4-753a-82e3-4d247263fdd3.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ3dsTYGB7xlYRGGe8LrwNnZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_55aa4877-4db5-4f07-8720-5b5aa125a39f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Three Bears Alaska",
      "poi_type": "Shopping & Retail",
      "poi_address": "10575 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "Versatile grocery store specializing in bulk supplies and fresh deli offerings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e3-48d6-756b-b7d6-95de50efb588.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e3-48d6-756b-b7d6-95de50efb588",
        "storage_key": "property/6767906449167173/01a140e3-48d6-756b-b7d6-95de50efb588.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://threebearsalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12705147429272922967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-bears-alaska",
      "poi_latitude": "60.558056699999995",
      "poi_longitude": "-151.23779639999998",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-6577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c630-736d-a4e5-608b6fb4c17b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c630-736d-a4e5-608b6fb4c17b",
        "storage_key": "property/6767906449167173/019d021c-c630-736d-a4e5-608b6fb4c17b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY86kAmB7xlYRV6vHrEXAUbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0556f1fd-aef0-4221-91e8-17376a2e807d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "10576 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-66c7-72a5-98a9-efb5ab07bc62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-66c7-72a5-98a9-efb5ab07bc62",
        "storage_key": "property/6767906449167173/019d021c-66c7-72a5-98a9-efb5ab07bc62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.safeway.com/safeway/ak/kenai/10576-kenai-spur-hwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11964597758568059406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "60.560186900000005",
      "poi_longitude": "-151.2408085",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-283-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c630-736d-a4e5-608b6fb4c17b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c630-736d-a4e5-608b6fb4c17b",
        "storage_key": "property/6767906449167173/019d021c-c630-736d-a4e5-608b6fb4c17b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWG6KWB7xlYRDlLiL0XKCqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_01031c40-4227-42ef-a32a-4c6497c8f088",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "10096 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "Large department store featuring a wide selection of groceries, clothing, and household goods at affordable prices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-6d7b-763e-ae77-5a0e60567c35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-6d7b-763e-ae77-5a0e60567c35",
        "storage_key": "property/6767906449167173/019d021c-6d7b-763e-ae77-5a0e60567c35.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4474-kenai-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3471712416094702019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "60.56405349999999",
      "poi_longitude": "-151.2260677",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-395-0971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c9b6-7709-905a-bc2b4eff6fd3",
        "storage_key": "property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyWixll17xlYRw0mjawwALjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b4fcda0e-c1dc-4a36-afac-39b494fc2fe5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "10671 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "Convenience store chain with coffee, prepared foods, and late-night hours.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-e37d-71d2-a5fc-c50054648296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-e37d-71d2-a5fc-c50054648296",
        "storage_key": "property/6767906449167173/01a140e4-e37d-71d2-a5fc-c50054648296.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/kenai/10671-kenai-spur-hwy/2746636?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7466579849041993391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "60.55732459999999",
      "poi_longitude": "-151.24007319999998",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-8130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0dea-7106-b938-abf28ab6847b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140e5-0dea-7106-b938-abf28ab6847b",
        "storage_key": "property/6767906449167173/01a140e5-0dea-7106-b938-abf28ab6847b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ1cQzTZ58xlYRr948JdCenmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_b82e4fe8-f763-4d5b-8121-4b37c33b0a1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Bargain Basement",
      "poi_type": "Shopping & Retail",
      "poi_address": "11472 Kenai Spur Hwy #1, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-e548-77e8-af88-40928489f8a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-e548-77e8-af88-40928489f8a4",
        "storage_key": "property/6767906449167173/01a140e4-e548-77e8-af88-40928489f8a4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=810449838633667107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bargain-basement",
      "poi_latitude": "60.555707",
      "poi_longitude": "-151.260603",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-283-3350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c9b6-7709-905a-bc2b4eff6fd3",
        "storage_key": "property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNeaubJt8xlYRI0oIlNVLPws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thrift_store"
    },
    {
      "id": "custom_a65a408d-e905-459b-b065-1d423b2052fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Chamber of Commerce and Visitors Center",
      "poi_type": "Entertainment",
      "poi_address": "11471 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "Informative visitor center featuring cultural and historical museum exhibits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-83f8-76a0-aaf2-2965197902f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-83f8-76a0-aaf2-2965197902f7",
        "storage_key": "property/6767906449167173/019d021c-83f8-76a0-aaf2-2965197902f7.webp",
        "width": 691,
        "height": 691
      },
      "poi_business_url": "https://www.kenaichamber.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1542919750558502593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-chamber-of-commerce-and-visitors-center",
      "poi_latitude": "60.55472859999999",
      "poi_longitude": "-151.26158959999998",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-283-1991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0dff-7454-892c-6707d2ff461e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140e5-0dff-7454-892c-6707d2ff461e",
        "storage_key": "property/6767906449167173/01a140e5-0dff-7454-892c-6707d2ff461e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQy44Zp8xlYRwU75oFaNaRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_d57bbd83-2d05-4d72-a3f4-a85adda0e6c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Alaska Trading and Loan",
      "poi_type": "Shopping & Retail",
      "poi_address": "241 N Aspen Dr, Soldotna, AK 99669, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-e7ac-75ed-b547-cbee97c82b56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-e7ac-75ed-b547-cbee97c82b56",
        "storage_key": "property/6767906449167173/01a140e4-e7ac-75ed-b547-cbee97c82b56.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14352196713457528651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-trading-and-loan",
      "poi_latitude": "60.49359390000001",
      "poi_longitude": "-151.0701225",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-262-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c9b6-7709-905a-bc2b4eff6fd3",
        "storage_key": "property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJW66uBxpjxlYRSy8qpN4-Lcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_13ab419f-9b80-4685-9274-1ed7e77a1a22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Rehome Thrift Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "11888 Kenai Spur Hwy #1, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-e672-7229-8926-34db1a4d631f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-e672-7229-8926-34db1a4d631f",
        "storage_key": "property/6767906449167173/01a140e4-e672-7229-8926-34db1a4d631f.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.facebook.com/Rehome-Thrift-Store-2320243961567338/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14303839593895433165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rehome-thrift-store",
      "poi_latitude": "60.5598669",
      "poi_longitude": "-151.2686503",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-283-0808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c9b6-7709-905a-bc2b4eff6fd3",
        "storage_key": "property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ23MrPt59xlYRzRNOXlNygcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thrift_store"
    },
    {
      "id": "custom_dead34b3-fdfa-42d4-a4b7-854f98ce1536",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Feed & Supply",
      "poi_type": "Shopping & Retail",
      "poi_address": "38612 Kalifornsky Beach Rd, Kenai, AK 99611, USA",
      "poi_short_description": "Farm supply store stocked with fertilizers, fencing, dog food and horse supplies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-e9a0-7246-825e-a67259df7451.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-e9a0-7246-825e-a67259df7451",
        "storage_key": "property/6767906449167173/01a140e4-e9a0-7246-825e-a67259df7451.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.kenaifeed.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16160939926736868182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-feed--supply",
      "poi_latitude": "60.516077300000006",
      "poi_longitude": "-151.2574961",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-283-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c9b6-7709-905a-bc2b4eff6fd3",
        "storage_key": "property/6767906449167173/019d021c-c9b6-7709-905a-bc2b4eff6fd3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr5eE_5p8xlYRVhOUMT0xR-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_843210fd-39c2-4871-97e0-6c40d930d7bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Three Bears Convenience Store",
      "poi_type": "Transportation & Transit",
      "poi_address": "10489 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://threebearsalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=392141143639594263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-bears-convenience-store",
      "poi_latitude": "60.5582357",
      "poi_longitude": "-151.2374472",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c9b3-73bc-b1cf-cb3e51e1519b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c9b3-73bc-b1cf-cb3e51e1519b",
        "storage_key": "property/6767906449167173/019d021c-c9b3-73bc-b1cf-cb3e51e1519b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJpb4WvfJ9xlYRFxV04EoqcQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_fc9ea9fd-a282-44eb-a582-0fcf42cbc816",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Mountain View Elementary School",
      "poi_type": "Education",
      "poi_address": "315 Swires Rd, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://mtviewelementary.blogs.kpbsd.k12.ak.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4508370367384114601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-view-elementary-school",
      "poi_latitude": "60.5653288",
      "poi_longitude": "-151.17607980000002",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-283-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJue2aM0t7xlYRqdXTd_bykD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_25ce3ffb-8b7c-4717-83f6-1edcd6a9519b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Middle School",
      "poi_type": "Education",
      "poi_address": "201 N Tinker Ln, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://kenaimiddleschool.blogs.kpbsd.k12.ak.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1232135341496675331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-middle-school",
      "poi_latitude": "60.5627222",
      "poi_longitude": "-151.2061698",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-283-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzVfpn1p7xlYRAywdoZBsGRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9c7828b9-eb25-4c8e-bead-f6a3ac327253",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Central High School",
      "poi_type": "Education",
      "poi_address": "9583 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://kpbsd.org/schools/kenai-central/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4036036230202279181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-central-high-school",
      "poi_latitude": "60.5610863",
      "poi_longitude": "-151.2126298",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-283-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt4TlV1p7xlYRDUXQSZHhAjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_cd5f63e8-3f21-488d-b170-d4a987dfdcfa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Aurora Borealis Charter School",
      "poi_type": "Education",
      "poi_address": "705 Frontage Rd B, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://kpbsd.org/schools/aurora-borealis/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6725474971291233657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aurora-borealis-charter-school",
      "poi_latitude": "60.554100000000005",
      "poi_longitude": "-151.255",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-283-0292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy673tZt8xlYReS2YcdqvVV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d604b26d-f42d-4dbb-905e-cb9d32aaaa6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kaleidoscope Charter School",
      "poi_type": "Education",
      "poi_address": "549 N Forest Dr, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://kpbsd.org/schools/kaleidoscope/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9861146860120049164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaleidoscope-charter-school",
      "poi_latitude": "60.5681348",
      "poi_longitude": "-151.2788353",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-283-0804",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrRVvfH98xlYRDAZqm9LU2Yg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a4b39f6d-8488-4a23-a703-b55d2049309f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Alternative High School",
      "poi_type": "Education",
      "poi_address": "705 Frontage Rd B, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://kenaialternativehigh.blogs.kpbsd.k12.ak.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5514035381785569984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-alternative-high-school",
      "poi_latitude": "60.55392409999999",
      "poi_longitude": "-151.2536357",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-335-2870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy673tZt8xlYRwKpDEvfJhUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7a41883b-2be6-47ab-b2c2-43797ed320fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Marathon School",
      "poi_type": "Education",
      "poi_address": "405 Marathon Rd, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14745494983448917604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marathon-school",
      "poi_latitude": "60.5668204",
      "poi_longitude": "-151.2321861",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-335-3343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL5ry8WZ7xlYRZPbG_Y-Fosw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a27e63c9-aefc-4503-88ef-494f00485d36",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Reads Primary School",
      "poi_type": "Education",
      "poi_address": "105 N Gill St, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10266594598144518637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reads-primary-school",
      "poi_latitude": "60.561581",
      "poi_longitude": "-151.279511",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-2848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cea3-74ed-8503-a2cb8b27c45b",
        "storage_key": "property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVFiW4d8xlYR7SlZa2RFeo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_65e71365-938c-4c8d-9f8a-79f6227afd67",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Peninsula College",
      "poi_type": "Education",
      "poi_address": "156 College Rd, Soldotna, AK 99669, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-82b5-7588-bfee-70eb421942b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-82b5-7588-bfee-70eb421942b3",
        "storage_key": "property/6767906449167173/019d021c-82b5-7588-bfee-70eb421942b3.webp",
        "width": 1280,
        "height": 759
      },
      "poi_business_url": "https://kpc.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6036018571963579507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-peninsula-college",
      "poi_latitude": "60.4855608",
      "poi_longitude": "-151.1280552",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 877-262-0330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ62keqLVjxlYRc7yMN-k-xFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bc60e5ea-2fd0-4a0f-8242-4dbe8ce1a43a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Challenger Learning Center of Alaska",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9711 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-effb-70bf-85b0-cf4f0a7d1f7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-effb-70bf-85b0-cf4f0a7d1f7c",
        "storage_key": "property/6767906449167173/01a140e4-effb-70bf-85b0-cf4f0a7d1f7c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17374611275329811348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "challenger-learning-center-of-alaska",
      "poi_latitude": "60.56167129999999",
      "poi_longitude": "-151.2163625",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-477-7926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ15rX8Ft7xlYRlLOHeOYEH_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_54be9df7-4e58-41e7-afa0-5fad6da45f8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Daubenspeck Family Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Marathon Rd, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-eaca-71b9-b5a3-a70b96f5799d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-eaca-71b9-b5a3-a70b96f5799d",
        "storage_key": "property/6767906449167173/01a140e4-eaca-71b9-b5a3-a70b96f5799d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15418835017404170110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daubenspeck-family-park",
      "poi_latitude": "60.5656176",
      "poi_longitude": "-151.230717",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cfcf-72a9-a781-f37131ea5af1",
        "storage_key": "property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZiJegB7xlYRfr-6fsG0-tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9e73bd7e-32fd-4e83-baf6-3ddfcbd99085",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Joe's",
      "poi_type": "Restaurants",
      "poi_address": "801 Cook Dr, Kenai, AK 99611, USA",
      "poi_short_description": "Laid-back local bar featuring craft cocktails and karaoke.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-eabc-779a-9da5-614afbd32548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-eabc-779a-9da5-614afbd32548",
        "storage_key": "property/6767906449167173/01a140e4-eabc-779a-9da5-614afbd32548.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Kenai-Joes-Taphouse-622283848286680",
      "poi_directions_map_url": "https://maps.google.com/?cid=11598889175943238539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-joes",
      "poi_latitude": "60.552239199999995",
      "poi_longitude": "-151.25578249999998",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-283-5637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c636-7091-9af7-73f9eeec80d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c636-7091-9af7-73f9eeec80d0",
        "storage_key": "property/6767906449167173/019d021c-c636-7091-9af7-73f9eeec80d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6MhjJl8xlYRi1M4gUCI96A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_3c91bea0-4b58-4388-86f9-c1b3e663c2b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Skeets Dive Bar",
      "poi_type": "Restaurants",
      "poi_address": "502 Main St, Kenai, AK 99611, USA",
      "poi_short_description": "Laid-back venue offering a selection of cold beers and cocktails alongside karaoke and pool tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-fb25-77ac-a4c1-118c716b214b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-fb25-77ac-a4c1-118c716b214b",
        "storage_key": "property/6767906449167173/01a140e4-fb25-77ac-a4c1-118c716b214b.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://www.instagram.com/skeetsdivebar?igsh=MWVycHk1MHRhZ2M4cQ==",
      "poi_directions_map_url": "https://maps.google.com/?cid=8712943660010240907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skeets-dive-bar",
      "poi_latitude": "60.5536881",
      "poi_longitude": "-151.260094",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-226-1187",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-c636-7091-9af7-73f9eeec80d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-c636-7091-9af7-73f9eeec80d0",
        "storage_key": "property/6767906449167173/019d021c-c636-7091-9af7-73f9eeec80d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3enu85p8xlYRi_vmehiY6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_fdf58249-9d50-4871-91a8-00fa70b164fb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Municipal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "301 S Forest Dr, Kenai, AK 99611, USA",
      "poi_short_description": "Versatile city park featuring family-friendly playgrounds and beach access.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-eeb3-76b5-b069-f23e5f77cf79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-eeb3-76b5-b069-f23e5f77cf79",
        "storage_key": "property/6767906449167173/01a140e4-eeb3-76b5-b069-f23e5f77cf79.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kenai.city/parksrec/page/kenai-municipal-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2387067144797375869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-municipal-park",
      "poi_latitude": "60.55673529999999",
      "poi_longitude": "-151.27726579999998",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cfcf-72a9-a781-f37131ea5af1",
        "storage_key": "property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7wPEYZ8xlYRfU2nxOuQICE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_5dccd148-bac2-485d-9b4b-c83728fc74a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Wildflower Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "402 Lawton Dr, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-f194-7588-b52e-ddb79e3e43ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-f194-7588-b52e-ddb79e3e43ce",
        "storage_key": "property/6767906449167173/01a140e4-f194-7588-b52e-ddb79e3e43ce.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6264623186009475546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wildflower-garden",
      "poi_latitude": "60.5602765",
      "poi_longitude": "-151.2230871",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-262-0262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0df9-7344-9178-03d2b6ef5746.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140e5-0df9-7344-9178-03d2b6ef5746",
        "storage_key": "property/6767906449167173/01a140e5-0df9-7344-9178-03d2b6ef5746.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ87LeIel7xlYR2knFpZhp8FY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_ece3a184-169b-4330-8a5b-becd56a07e99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai River Brewing Co",
      "poi_type": "Restaurants",
      "poi_address": "308 Homestead Ln, Soldotna, AK 99669, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-901a-7487-bdf0-1a63979e4120.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-901a-7487-bdf0-1a63979e4120",
        "storage_key": "property/6767906449167173/019d021c-901a-7487-bdf0-1a63979e4120.webp",
        "width": 658,
        "height": 384
      },
      "poi_business_url": "http://www.kenairiverbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5905574841573888732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-river-brewing-co",
      "poi_latitude": "60.4846083",
      "poi_longitude": "-151.0572707",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 907-262-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cea3-74ed-8503-a2cb8b27c45b",
        "storage_key": "property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE2DIg2ZhxlYR3NJ-ggfR9FE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_f8494521-e47f-468a-bc1f-44c35a6d7791",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Central Peninsula Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "250 Hospital Pl, Soldotna, AK 99669, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-91a1-77ab-943a-7f67ec271c7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-91a1-77ab-943a-7f67ec271c7c",
        "storage_key": "property/6767906449167173/019d021c-91a1-77ab-943a-7f67ec271c7c.webp",
        "width": 1024,
        "height": 701
      },
      "poi_business_url": "http://www.cpgh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17385792145635733085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-peninsula-hospital",
      "poi_latitude": "60.49341559999999",
      "poi_longitude": "-151.078362",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-714-4404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d05b-71de-b033-a4647e8ce7b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d05b-71de-b033-a4647e8ce7b8",
        "storage_key": "property/6767906449167173/019d021c-d05b-71de-b033-a4647e8ce7b8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6cjWLGFhxlYRXe5ks9e9RvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_86e4f4a9-7f5a-4ff7-994b-e85c8ea78113",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Central Peninsula Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "10128 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-f5be-7783-bc09-ae38eaaa9a7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-f5be-7783-bc09-ae38eaaa9a7e",
        "storage_key": "property/6767906449167173/01a140e4-f5be-7783-bc09-ae38eaaa9a7e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kenaiurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13718695235124277821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-peninsula-urgent-care",
      "poi_latitude": "60.561532",
      "poi_longitude": "-151.2268761",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-714-5740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cea3-74ed-8503-a2cb8b27c45b",
        "storage_key": "property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq1pKOZB7xlYRPTJtr6GYYr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_53f6fe8b-4dfd-4df8-a304-93454802447d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Peninsula Community Health Services Medical Center-Kenai",
      "poi_type": "Health and Wellness",
      "poi_address": "805 Frontage Rd, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pchsak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9042370211079347860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peninsula-community-health-services-medical-center-kenai",
      "poi_latitude": "60.55401930000001",
      "poi_longitude": "-151.2577018",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-262-3119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cea3-74ed-8503-a2cb8b27c45b",
        "storage_key": "property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFd2F6xJ9xlYRlF71ZszzfH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6baeb468-abce-4592-a958-7ef983d05149",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10096 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-9751-7789-a704-b6404ca9e245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-9751-7789-a704-b6404ca9e245",
        "storage_key": "property/6767906449167173/019d021c-9751-7789-a704-b6404ca9e245.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/4474-kenai-ak/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9191611333862497986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "60.5640635",
      "poi_longitude": "-151.22490520000002",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-395-0871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d363-758b-85b0-8a6286669124.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d363-758b-85b0-8a6286669124",
        "storage_key": "property/6767906449167173/019d021c-d363-758b-85b0-8a6286669124.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWixll17xlYRwh5UFM8pj38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_bf7a4026-75f7-4610-8d5e-ec3c9f320814",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Safeway Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10576 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-97bb-74a9-baa3-8083afc931ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-97bb-74a9-baa3-8083afc931ae",
        "storage_key": "property/6767906449167173/019d021c-97bb-74a9-baa3-8083afc931ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.safeway.com/safeway/ak/kenai/10576-kenai-spur-hwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4962874451254269510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway-pharmacy",
      "poi_latitude": "60.56019",
      "poi_longitude": "-151.2408721",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-283-6360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d363-758b-85b0-8a6286669124.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d363-758b-85b0-8a6286669124",
        "storage_key": "property/6767906449167173/019d021c-d363-758b-85b0-8a6286669124.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwj-1p98xlYRRlbf2wSs30Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_17248146-a848-4192-8f04-43c38461708c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Three Bears Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10575 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-f54e-705d-9feb-15db52ff2f35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-f54e-705d-9feb-15db52ff2f35",
        "storage_key": "property/6767906449167173/01a140e4-f54e-705d-9feb-15db52ff2f35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://threebearsalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11274230809846479932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-bears-pharmacy",
      "poi_latitude": "60.5579866",
      "poi_longitude": "-151.2373316",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-335-2061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d363-758b-85b0-8a6286669124.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d363-758b-85b0-8a6286669124",
        "storage_key": "property/6767906449167173/019d021c-d363-758b-85b0-8a6286669124.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY86kAmB7xlYRPPypKDAddpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_489dcf4b-e105-4fc9-964b-62cfd56bf55b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "227 Caviar St, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-f67b-72ff-948c-17954a055a8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-f67b-72ff-948c-17954a055a8e",
        "storage_key": "property/6767906449167173/01a140e4-f67b-72ff-948c-17954a055a8e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kenai.city/parksrec",
      "poi_directions_map_url": "https://maps.google.com/?cid=6406620094312000475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-recreation-center",
      "poi_latitude": "60.5564705",
      "poi_longitude": "-151.2484088",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-8265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d41b-74a9-a220-b0e2d0f5fa69",
        "storage_key": "property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SHMpZ58xlYR26tYNAjj6Fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_ff82e3ac-2447-4be2-a360-c8c71e953a82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Tides Yoga Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "36671 Phillips Dr, Kenai, AK 99611, USA",
      "poi_short_description": "Welcoming yoga and pole fitness studio featuring a wide variety of classes and teacher training programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-9da4-76a6-9927-1b5cfef506a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-9da4-76a6-9927-1b5cfef506a8",
        "storage_key": "property/6767906449167173/019d021c-9da4-76a6-9927-1b5cfef506a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tidesyogastudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3480310399499484187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tides-yoga-studio",
      "poi_latitude": "60.5113884",
      "poi_longitude": "-151.1748835",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-513-5614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiTmGoJ98xlYRG7xDbt6LTDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_12049ee9-e22e-47ed-9e93-7077f663475b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Dena'ina Wellness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "508 Upland Dr, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-9d5b-722e-8c88-7e0ae2d0f1f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-9d5b-722e-8c88-7e0ae2d0f1f8",
        "storage_key": "property/6767906449167173/019d021c-9d5b-722e-8c88-7e0ae2d0f1f8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://kenaitze.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16395859600120795568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denaina-wellness-center",
      "poi_latitude": "60.5528658",
      "poi_longitude": "-151.2642664",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-335-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cea3-74ed-8503-a2cb8b27c45b",
        "storage_key": "property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJseAHGp98xlYRsNFg9G_LieM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_318fc881-d23f-437b-bed1-1499e4c1b615",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Select Physical Therapy - Kenai",
      "poi_type": "Health and Wellness",
      "poi_address": "220 Main St Loop Unit A, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-fd82-77aa-99bc-1af132ba236b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-fd82-77aa-99bc-1af132ba236b",
        "storage_key": "property/6767906449167173/01a140e4-fd82-77aa-99bc-1af132ba236b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.selectphysicaltherapy.com/contact/find-a-location/ak/kenai/kenai/?ty=xt",
      "poi_directions_map_url": "https://maps.google.com/?cid=3445795953242736094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "select-physical-therapy---kenai",
      "poi_latitude": "60.55991",
      "poi_longitude": "-151.2481344",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-335-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cea3-74ed-8503-a2cb8b27c45b",
        "storage_key": "property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS5gF7Ol9xlYR3gWDsSnt0S8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_575fc5e8-8163-4e31-9677-0da50b3cbe73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Meeks Trail to Kenai North Beach",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1013-1017 Alaska Ave, Kenai, AK 99611, USA",
      "poi_short_description": "Beachy recreation spot with a trail down to the sand, plus birds like bald eagles and seagulls.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-fad2-76da-a722-609c9b913224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-fad2-76da-a722-609c9b913224",
        "storage_key": "property/6767906449167173/01a140e4-fad2-76da-a722-609c9b913224.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kenai.city/parksrec/page/meeks-trail",
      "poi_directions_map_url": "https://maps.google.com/?cid=7270404101375981614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meeks-trail-to-kenai-north-beach",
      "poi_latitude": "60.5522904",
      "poi_longitude": "-151.2689464",
      "poi_miles_from_property": "0.01",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-283-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0deb-70de-88b9-b7ae5d5a3b16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140e5-0deb-70de-88b9-b7ae5d5a3b16",
        "storage_key": "property/6767906449167173/01a140e5-0deb-70de-88b9-b7ae5d5a3b16.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28YM6I98xlYRLvgOjAKq5WQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_36de5575-7a1f-4899-8f72-757ad64e17d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Erik Hansen Scout Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "913 Mission Ave, Kenai, AK 99611, USA",
      "poi_short_description": "Scenic city park featuring a beach, benches, and salmon netting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e4-ff80-74a2-ba16-cd5b83d3fd95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e4-ff80-74a2-ba16-cd5b83d3fd95",
        "storage_key": "property/6767906449167173/01a140e4-ff80-74a2-ba16-cd5b83d3fd95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kenai.city/parksrec/page/erik-hansen-scout-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2841764732075576700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "erik-hansen-scout-park",
      "poi_latitude": "60.55101489999999",
      "poi_longitude": "-151.2639834",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-283-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cfcf-72a9-a781-f37131ea5af1",
        "storage_key": "property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88Tk99N9xlYRfA2Zrvf5byc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_6586ef7e-741e-4b44-919b-92214b1704fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Old Town Kenai Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "816 Cook Dr, Kenai, AK 99611, USA",
      "poi_short_description": "Scenic park with a fire pit, plus books, fishing history, and views of Cook Inlet.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e3-6483-70be-a1ed-ba0ecfceb3fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e3-6483-70be-a1ed-ba0ecfceb3fa",
        "storage_key": "property/6767906449167173/01a140e3-6483-70be-a1ed-ba0ecfceb3fa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kenai.city/parksrec/page/old-town-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11950849228891400080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-kenai-park",
      "poi_latitude": "60.5523731",
      "poi_longitude": "-151.2580971",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-283-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cfcf-72a9-a781-f37131ea5af1",
        "storage_key": "property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRaWNbZp8xlYRkKdSLA7y2aU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_55bd029b-2d10-47d0-8273-8296823d506e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Cunningham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2432 Beaver Loop Rd, Kenai, AK 99611, USA",
      "poi_short_description": "Park with picnic tables and a public restroom suitable for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e3-60ab-7788-abe9-49a350aa558a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e3-60ab-7788-abe9-49a350aa558a",
        "storage_key": "property/6767906449167173/01a140e3-60ab-7788-abe9-49a350aa558a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kenai.city/parksrec/page/cunningham-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2546698566080716369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cunningham-park",
      "poi_latitude": "60.5414404",
      "poi_longitude": "-151.183379",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-283-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cfcf-72a9-a781-f37131ea5af1",
        "storage_key": "property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WGROFdjxlYRUd48VdqwVyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_739f243f-0031-4737-acfd-4cc43a1db0f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "210 Fidalgo Ave, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1609785222254642452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-city-hall",
      "poi_latitude": "60.5590191",
      "poi_longitude": "-151.24868",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-7535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d41b-74a9-a220-b0e2d0f5fa69",
        "storage_key": "property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJedtB3Z18xlYRFEUpcSEbVxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_28e11baf-49ee-442a-8bca-3dde1cb00251",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Beaver Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6031 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "Public park with a playground and picnic tables, plus a zip line and wildlife.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.kenai.city/parksrec/page/beaver-creek-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8030449638164073134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaver-creek-park",
      "poi_latitude": "60.5618784",
      "poi_longitude": "-151.1182911",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-283-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cfcf-72a9-a781-f37131ea5af1",
        "storage_key": "property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcb06etkxlYRrgpvFWbjcW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_fb7b8662-f2a8-424e-bc20-b41724fec517",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Leif Hansen Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10959 Kenai Spur Hwy, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-00a4-7639-889a-895a1d06ba6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e5-00a4-7639-889a-895a1d06ba6c",
        "storage_key": "property/6767906449167173/01a140e5-00a4-7639-889a-895a1d06ba6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kenai.city/parksrec/page/leif-hansen-memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=886560811901746033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leif-hansen-memorial-park",
      "poi_latitude": "60.555187999999994",
      "poi_longitude": "-151.245191",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-283-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cfcf-72a9-a781-f37131ea5af1",
        "storage_key": "property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6R6red9xlYRcXsveVyyTQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_58abe2bd-06e9-4b5a-9afc-1bf801696758",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Beach",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Kenai Beach, 1112 Kenai Ave, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-a403-716f-ab8e-f8b48b9ae7fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-a403-716f-ab8e-f8b48b9ae7fb",
        "storage_key": "property/6767906449167173/019d021c-a403-716f-ab8e-f8b48b9ae7fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ci.kenai.ak.us/recreation/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=1051617445725665606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-beach",
      "poi_latitude": "60.551963",
      "poi_longitude": "-151.273863",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-283-3692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0e46-74ea-8398-b8e9b216aece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140e5-0e46-74ea-8398-b8e9b216aece",
        "storage_key": "property/6767906449167173/01a140e5-0e46-74ea-8398-b8e9b216aece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi9bFqo98xlYRRvkUxH4YmA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "beach"
    },
    {
      "id": "custom_78469fb9-d041-4561-a0fd-15f87aa2dcc9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "305 N Willow St, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e3-6372-728e-b7f8-265dffa72942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e3-6372-728e-b7f8-265dffa72942",
        "storage_key": "property/6767906449167173/01a140e3-6372-728e-b7f8-265dffa72942.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kenai.city/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=11099802979690567805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-municipal-airport",
      "poi_latitude": "60.56501",
      "poi_longitude": "-151.2467651",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-283-7951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d3bd-766d-809e-219b0c5f7534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d3bd-766d-809e-219b0c5f7534",
        "storage_key": "property/6767906449167173/019d021c-d3bd-766d-809e-219b0c5f7534.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJaWatHGN7xlYRfVhHMQBsCpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_1cb6e18b-7847-4ad3-b164-af4619c3fef9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Avis Car Rental",
      "poi_type": "Transportation & Transit",
      "poi_address": "305 N Willow St, Kenai, AK 99611, USA",
      "poi_short_description": "Chain car rental agency located at the Kenai Municipal Airport.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0113-70ef-a1fe-79b99ae2e2d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e5-0113-70ef-a1fe-79b99ae2e2d8",
        "storage_key": "property/6767906449167173/01a140e5-0113-70ef-a1fe-79b99ae2e2d8.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.avis.com/en/locations/nam/us/ak/kenai/ena?utm_source=google&utm_medium=gbp&utm_campaign=avis_gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17001833980967865993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avis-car-rental",
      "poi_latitude": "60.565082999999994",
      "poi_longitude": "-151.2467",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-283-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0e4d-735b-9305-fd702e5939a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140e5-0e4d-735b-9305-fd702e5939a7",
        "storage_key": "property/6767906449167173/01a140e5-0e4d-735b-9305-fd702e5939a7.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJaWatHGN7xlYRiU7BFe2l8us",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_rental"
    },
    {
      "id": "custom_1e1de600-9479-4e40-9999-e79d976227e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Central Area Rural Transit System, Inc. (CARTS)",
      "poi_type": "Transportation & Transit",
      "poi_address": "35139 K B Dr, Soldotna, AK 99669, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-b5da-7662-a76b-658592c38be2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-b5da-7662-a76b-658592c38be2",
        "storage_key": "property/6767906449167173/019d021c-b5da-7662-a76b-658592c38be2.webp",
        "width": 1280,
        "height": 586
      },
      "poi_business_url": "http://www.ridecartsak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18160212972569028338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-area-rural-transit-system-inc-carts",
      "poi_latitude": "60.48959910000001",
      "poi_longitude": "-151.15228159999998",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-262-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cea3-74ed-8503-a2cb8b27c45b",
        "storage_key": "property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcZgkgNN8xlYR8uZqS3sJBvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_60cd798c-5a06-45fa-8e2c-1fafd1846e5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenaitze Indian Tribe IRA",
      "poi_type": "Health and Wellness",
      "poi_address": "150 N Willow St, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-bcf2-722d-a371-a3a72be37564.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-bcf2-722d-a371-a3a72be37564",
        "storage_key": "property/6767906449167173/019d021c-bcf2-722d-a371-a3a72be37564.webp",
        "width": 750,
        "height": 748
      },
      "poi_business_url": "https://www.kenaitze.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1474706438715006748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenaitze-indian-tribe-ira",
      "poi_latitude": "60.5620002",
      "poi_longitude": "-151.24690239999998",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-335-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cea3-74ed-8503-a2cb8b27c45b",
        "storage_key": "property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr19wQGJ7xlYRHN-WU7E1dxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f61415f5-1ddf-4d42-bddb-62a7f9295fea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "United States Postal Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "140 Bidarka St, Kenai, AK 99611, USA",
      "poi_short_description": "Local post office providing mail delivery services and walk-in passport processing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-05b1-73f5-a00c-049f9113956c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e5-05b1-73f5-a00c-049f9113956c",
        "storage_key": "property/6767906449167173/01a140e5-05b1-73f5-a00c-049f9113956c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://tools.usps.com/locations/details/1368821?utm_source=google-my-business-url&utm_medium=search&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=7918184389370349540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-postal-service",
      "poi_latitude": "60.5578143",
      "poi_longitude": "-151.2480766",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-275-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0e48-70cd-93dd-c1086cc76c31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140e5-0e48-70cd-93dd-c1086cc76c31",
        "storage_key": "property/6767906449167173/01a140e5-0e48-70cd-93dd-c1086cc76c31.webp",
        "width": 192,
        "height": 157
      },
      "poi_google_place_id": "ChIJvWH_hJ58xlYR5Id28r8K420",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "post_office"
    },
    {
      "id": "custom_357fb64c-d7a0-40bf-8b7b-6b3ac58cd7d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Wildwood Correctional Complex",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10 Chugach Ave, Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://alaska.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5142412097081633281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wildwood-correctional-complex",
      "poi_latitude": "60.584233999999995",
      "poi_longitude": "-151.30005219999998",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-260-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d41b-74a9-a220-b0e2d0f5fa69",
        "storage_key": "property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3TJAIo17xlYRAeo4f46EXUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_04b12c5a-7c81-4977-87e2-27ecaa2705da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Hilcorp Alaska (Cook Inlet)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Kenai, AK 99611, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17530913825084583275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilcorp-alaska-cook-inlet",
      "poi_latitude": "60.474227899999995",
      "poi_longitude": "-151.2745819",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cea3-74ed-8503-a2cb8b27c45b",
        "storage_key": "property/6767906449167173/019d021c-cea3-74ed-8503-a2cb8b27c45b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxze0v65ixlYRa60mvD1RSvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_36832d1d-f47c-4034-9a8e-e6c1e5bad2de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Peninsula Borough Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "144 N Binkley St, Soldotna, AK 99669, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-0779-706c-b6e7-8652011acdf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e5-0779-706c-b6e7-8652011acdf9",
        "storage_key": "property/6767906449167173/01a140e5-0779-706c-b6e7-8652011acdf9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kpb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3147061612259346783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-peninsula-borough-administration",
      "poi_latitude": "60.4895455",
      "poi_longitude": "-151.0713209",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-262-4441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d41b-74a9-a220-b0e2d0f5fa69",
        "storage_key": "property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbcsLOd9jxlYRX4n8zNybrCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_fb318644-bd6d-43d0-9219-0441c1cacadc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai Peninsula School District",
      "poi_type": "Education",
      "poi_address": "148 N Binkley St, Soldotna, AK 99669, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://kpbsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5283241083586371624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-peninsula-school-district",
      "poi_latitude": "60.490483000000005",
      "poi_longitude": "-151.0672809",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-714-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cb13-70a6-b687-536cb1e74a47",
        "storage_key": "property/6767906449167173/019d021c-cb13-70a6-b687-536cb1e74a47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsYXKKmBhxlYRKGDqEcbXUUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d9870cfd-a9af-4e4e-ad66-1d993bbf16c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Kenai National Wildlife Refuge Headquarters",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "33398 Ski Hill Rd, Soldotna, AK 99669, USA",
      "poi_short_description": "Extensive wilderness offering opportunities for hiking, camping, canoeing & wildlife viewing.",
      "poi_long_description": "Extensive wilderness offering opportunities for hiking, camping, canoeing & wildlife viewing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/01a140e5-08f7-75cf-88cd-bae177419265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140e5-08f7-75cf-88cd-bae177419265",
        "storage_key": "property/6767906449167173/01a140e5-08f7-75cf-88cd-bae177419265.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fws.gov/refuge/Kenai/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10931878828916260943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenai-national-wildlife-refuge-headquarters",
      "poi_latitude": "60.46446950000001",
      "poi_longitude": "-151.0737925",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 907-743-9145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-cfcf-72a9-a781-f37131ea5af1",
        "storage_key": "property/6767906449167173/019d021c-cfcf-72a9-a781-f37131ea5af1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb4Vun_NWxlYRT8AqFeDVtZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_f22e61e8-e857-4673-9ffb-bfa4073a96dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "custom",
      "poi_name": "Department Of Fish & Game",
      "poi_type": "Major Employers & Offices",
      "poi_address": "43961 Kalifornsky Beach Rd # B, Soldotna, AK 99669, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.adfg.alaska.gov/index.cfm?adfg=contacts.soldotna",
      "poi_directions_map_url": "https://maps.google.com/?cid=16005130176494337900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "department-of-fish--game",
      "poi_latitude": "60.4852104",
      "poi_longitude": "-151.152481",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-262-9368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d41b-74a9-a220-b0e2d0f5fa69",
        "storage_key": "property/6767906449167173/019d021c-d41b-74a9-a220-b0e2d0f5fa69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcyrAh1JixlYRbH_UwRilHd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a1e3d7aeb61ac720af807ec6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "day": "MON",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_854e51c80906d98138d8226a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "day": "TUE",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_23ca9f78b12f3d32d39999a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_82a8c0a9c291994e9ae5da07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "day": "FRI",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_a01381542242e084563f55f2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "rating": "5",
      "name": "Timothy Lehman",
      "text": "Fabulous!  Josh, Angus & Melissa were absolutely delightful!  They were super eager to please, friendly.  When they didn’t know an answer to our many questions, they got back to us quickly.  The renting/ leasing process was as painless as possible.  Overall, we are very excited about living here under exceptional management!",
      "date": "2019-08-15",
      "title": "false"
    },
    {
      "id": "ec_ae417d5678044ec0452eba7f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "rating": "5",
      "name": "MC Janitorial",
      "text": "My friend lives here and I’ve always loved the view from their place. We like taking the trail down to the water and walking to that cute restaurant close by. Quaint place to live!",
      "date": "2022-03-04",
      "title": "false"
    },
    {
      "id": "ec_e575aa0ca61c07f2a567ac95",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "rating": "4",
      "name": "Ted Anderson",
      "text": "Great location in Old Town Kenai with an awesome view of the Cook Inlet and Alaska Range. Maintenance and management have been professional.",
      "date": "2023-08-12",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_8cf403acd9c483afdaf6563b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "yardi",
      "external_id": "2226097",
      "pet_type": "none",
      "allowed": false,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-d69a-769d-89e3-f8065ccad113",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Bay Arms Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "waterfront-apartments-kenai-peninsula-bay-arms",
      "search_query": "waterfront apartments kenai peninsula",
      "category": "Amenity",
      "h1_title": "Waterfront Apartments Kenai Peninsula",
      "h2_subtitle": "Discover the charm of waterfront apartments on the Kenai Peninsula. Experience the unique lifestyle at Bay Arms located in Kenai, AK.",
      "page_copy": "Welcome to Bay Arms, where waterfront living on the beautiful Kenai Peninsula comes to life. Our community offers stunning views that allow you to enjoy the natural beauty of Kenai. Featuring amenities such as bike storage, a laundry room, and both on-site maintenance and management, Bay Arms is crafted to enhance your living experience.\n\nOur prime location means that you can immerse yourself in the vibrant lifestyle of the Kenai Peninsula while enjoying the comfort of waterfront apartments. At Bay Arms, we are committed to providing a community that resonates with the serenity and charm of Kenai, delivering unparalleled quality of life to our residents.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Waterfront Apartments Kenai Peninsula - Bay Arms",
      "seo_description": "Experience waterfront living at Bay Arms on Kenai Peninsula. Enjoy stunning views and modern amenities in Kenai, AK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-kenai-ak-bay-arms",
      "search_query": "smoke free apartments kenai ak",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in Kenai, AK",
      "h2_subtitle": "Bay Arms offers smoke-free apartment living in Kenai, AK. Enjoy clean air and a healthy environment at our welcoming community.",
      "page_copy": "When searching for smoke-free apartments in Kenai, AK, look no further than Bay Arms. Our smoke-free environment is designed to promote well-being and peace of mind. Located in the heart of Kenai Peninsula Borough, Bay Arms offers a tranquil setting for those seeking a clean and healthy lifestyle.\n\nWith amenities like convenient bike storage, a fully equipped laundry room, and professional on-site maintenance and management, Bay Arms ensures all your needs are met. Enjoy the refreshing air and community atmosphere as you make the most of smoke-free living in Kenai, AK. Come and see why Bay Arms is the ideal choice for those prioritizing a healthy home environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments Kenai, AK - Bay Arms",
      "seo_description": "Discover smoke-free living at Bay Arms in Kenai, AK. Enjoy a healthy lifestyle with clean air and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "bay-arms-large-closets-apartments-kenai",
      "search_query": "bay arms large closets apartments kenai",
      "category": "Amenity",
      "h1_title": "Bay Arms Large Closets Apartments",
      "h2_subtitle": "Find spacious large closet apartments at Bay Arms in Kenai. Your ideal home is ready for you on the Kenai Peninsula.",
      "page_copy": "Searching for large closets apartments in Kenai? Bay Arms provides the perfect blend of comfort and convenient storage options. Our spacious apartments are designed to meet your needs, offering ample storage with large closets so you can enjoy a clutter-free living environment.\n\nLocated in the serene Kenai Peninsula, Bay Arms is equipped with amenities like bike storage, laundry facilities, and on-site maintenance. Our commitment to quality ensures that you have everything you need at your fingertips. Enjoy the comfortable lifestyle and generous storage that large closets apartments in Kenai at Bay Arms can offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bay Arms Large Closets Apartments in Kenai",
      "seo_description": "Discover spacious living at Bay Arms in Kenai with large closets and desirable amenities. Your ideal home awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "patio-balcony-apartments-kenai-peninsula-bay-arms",
      "search_query": "patio balcony apartments kenai peninsula borough",
      "category": "Amenity",
      "h1_title": "Patio Balcony Apartments in Kenai Peninsula",
      "h2_subtitle": "Enjoy patio balcony apartments at Bay Arms, Kenai Peninsula Borough. Bask in the beauty of Kenai from the comfort of your home.",
      "page_copy": "Explore the luxury of patio balcony apartments at Bay Arms, located in the Kenai Peninsula Borough. These apartments are designed with your comfort in mind, allowing you to soak in breathtaking views from your own patio or balcony. Experience the beauty of nature around Kenai while you enjoy the privacy of your own outdoor space.\n\nBay Arms ensures a fulfilling living experience with additional amenities like bike storage, laundry facilities, and dedicated on-site management. Our commitment to quality and comfort makes Bay Arms the perfect choice for those seeking patio balcony apartments in the Kenai Peninsula Borough. Discover the joys of outdoor living at Bay Arms.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Patio Balcony Apartments Kenai Peninsula - Bay Arms",
      "seo_description": "Find patio balcony apartments at Bay Arms in Kenai Peninsula Borough. Enjoy stunning views from your home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "community-garden-apartments-99611-bay-arms",
      "search_query": "community garden apartments in 99611",
      "category": "Amenity",
      "h1_title": "Community Garden Apartments in 99611",
      "h2_subtitle": "Experience the charm of community garden apartments at Bay Arms. Located in the heart of Kenai, AK, in the 99611 area.",
      "page_copy": "Looking for community garden apartments in the 99611 zip code? At Bay Arms, we understand the value of community connection and greenery. Our residents enjoy access to beautifully designed community garden spaces where they can relax and mingle.\n\nBay Arms in Kenai provides a range of amenities, including bike storage, a laundry room, and reliable on-site management. With picturesque views and a vibrant community garden, Bay Arms offers a tranquil lifestyle in Kenai, AK. Embrace the serene living environment Bay Arms offers in the 99611 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Community Garden Apartments in 99611 - Bay Arms",
      "seo_description": "Discover community garden living at Bay Arms in Kenai, 99611. Enjoy vibrant green spaces and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "studio-apartments-kenai-ak-bay-arms",
      "search_query": "studio apartments Kenai AK",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Kenai, AK",
      "h2_subtitle": "Discover cozy studio apartments at Bay Arms in Kenai, AK. Perfect for comfortable and convenient living.",
      "page_copy": "If you're seeking studio apartments in Kenai, AK, Bay Arms has just what you need. Our thoughtfully designed studio apartments offer the perfect blend of comfort and function, making them ideal for anyone looking to live simply yet stylishly.\n\nSituated in scenic Kenai, Bay Arms provides essential amenities like bike storage, on-site management, and laundry facilities. Our studio apartments are crafted to provide a comfortable and hassle-free lifestyle. Discover the serene and convenient living that studio apartments in Kenai, AK, at Bay Arms can provide.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Kenai, AK - Bay Arms",
      "seo_description": "Explore Bay Arms studio apartments in Kenai, AK. Enjoy cozy living with essential amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-kenai-peninsula-bay-arms",
      "search_query": "1 bedroom apartments Kenai Peninsula",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments Kenai Peninsula",
      "h2_subtitle": "Explore modern 1 bedroom apartments at Bay Arms in the Kenai Peninsula. Ideal for both comfort and convenience.",
      "page_copy": "Looking for 1 bedroom apartments on the Kenai Peninsula? Bay Arms offers spacious and well-designed units perfect for singles or couples seeking a cozy living space. Each apartment is thoughtfully equipped to provide a homely feel while ensuring functionality.\n\nLocated in the heart of the Kenai Peninsula, Bay Arms boasts amenities such as on-site maintenance, a laundry room, and scenic views. Our 1 bedroom apartments are the epitome of comfort and lifestyle, nestled in the beautiful surroundings of Kenai Peninsula Borough. Experience top-tier living at Bay Arms.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Kenai Peninsula - Bay Arms",
      "seo_description": "Find your ideal 1 bedroom apartment at Bay Arms in Kenai Peninsula. Comfortable and stylish living with essential amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-99611-bay-arms",
      "search_query": "2 bedroom apartments near 99611",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 99611",
      "h2_subtitle": "Discover ideal living with 2 bedroom apartments near 99611 at Bay Arms. Spacious units in beautiful Kenai, AK.",
      "page_copy": "Searching for spacious 2 bedroom apartments near the 99611 area? Look no further than Bay Arms, where comfort meets functionality. Our 2 bedroom units are perfect for families or roommates who value space and convenience.\n\nSituated in Kenai, AK, Bay Arms provides a host of amenities like on-site maintenance and management, bike storage, and a laundry room. Each apartment offers stunning views and a welcoming atmosphere, making Bay Arms the perfect choice for those seeking a well-rounded lifestyle near the 99611 zip code.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 99611 - Bay Arms",
      "seo_description": "Explore spacious 2 bedroom apartments near 99611 at Bay Arms in Kenai, AK. Enjoy a comfortable living experience with full amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-kenai-borough-bay-arms",
      "search_query": "3 bedroom apartments Kenai Borough",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Kenai Borough",
      "h2_subtitle": "Discover spacious 3 bedroom apartments at Bay Arms in Kenai Borough, ideal for family living.",
      "page_copy": "In search of spacious 3 bedroom apartments in the Kenai Borough? Bay Arms provides the perfect solution with our expansive and modern units designed to accommodate families or those who crave more space.\n\nNestled in the scenic Kenai Borough, Bay Arms offers amenities like a laundry room, bike storage, and reliable on-site maintenance. Each 3 bedroom apartment is designed for comfortable and convenient living, ensuring residents enjoy a perfect balance of serenity and accessibility. Choose Bay Arms for enhanced living in Kenai Borough.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Kenai Borough - Bay Arms",
      "seo_description": "Find spacious 3 bedroom apartments in Kenai Borough at Bay Arms. Designed for comfortable family living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-christian-college-bay-arms",
      "search_query": "apartments near Alaska Christian College Kenai Peninsula",
      "category": "School",
      "h1_title": "Apartments Near Alaska Christian College",
      "h2_subtitle": "Convenience and comfort meet at Bay Arms, conveniently located near Alaska Christian College in the Kenai Peninsula.",
      "page_copy": "Looking for convenient apartments near Alaska Christian College on the Kenai Peninsula? Bay Arms provides the perfect setting for students and faculty alike. Our apartments offer a blend of comfort and accessibility, making it easy to enjoy both campus life and the surrounding community.\n\nSituated in the vibrant Kenai Peninsula, Bay Arms features amenities such as on-site management, laundry facilities, and picturesque views. Whether you're a student, educator, or staff member, Bay Arms has the amenities and proximity you need for an ideal living experience near the college.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Christian College - Bay Arms",
      "seo_description": "Discover convenient, comfortable living at Bay Arms, close to Alaska Christian College in the Kenai Peninsula. Ideal for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "apartments-near-kenai-south-beach-bay-arms",
      "search_query": "apartments near Kenai South Beach",
      "category": "Park",
      "h1_title": "Apartments Near Kenai South Beach",
      "h2_subtitle": "Enjoy coastal living in apartments near Kenai South Beach at Bay Arms. Perfect for beach lovers in Kenai, AK.",
      "page_copy": "Experience the charm of coastal living with apartments near Kenai South Beach, right here at Bay Arms. Offering a serene environment and modern amenities, Bay Arms is ideal for those who revel in the beach lifestyle.\n\nLocated just a short distance from Kenai South Beach, our community provides amenities such as bike storage, a laundry room, and on-site maintenance. Bay Arms is the perfect blend of relaxation and convenience, giving you easy access to both sandy shores and city comforts. Choose Bay Arms for your new home near Kenai South Beach.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kenai South Beach - Bay Arms",
      "seo_description": "Live close to the coast with Bay Arms, featuring apartments near Kenai South Beach. Enjoy relaxed coastal living with full amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "kenai-eagle-rock-boat-launch-apartments-bay-arms",
      "search_query": "Kenai Eagle Rock Boat Launch apartments",
      "category": "Park",
      "h1_title": "Kenai Eagle Rock Boat Launch Apartments",
      "h2_subtitle": "Discover Bay Arms, the perfect apartments near Kenai Eagle Rock Boat Launch, offering convenience and comfort for water enthusiasts.",
      "page_copy": "Looking for apartments near Kenai Eagle Rock Boat Launch? Bay Arms apartments provide an ideal location for those who love spending time on the water. Nestled in the heart of Kenai, our community offers easy access to the Eagle Rock Boat Launch, ensuring you’re always ready for your next fishing or boating adventure.\n\nIn addition to proximity to the Eagle Rock Boat Launch, Bay Arms features amenities such as a laundry room, bike storage, and on-site management. Our friendly community atmosphere and convenient location make Bay Arms the perfect home for those wishing to combine their passion for the water with comfortable living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kenai Eagle Rock Boat Launch Apts - Bay Arms",
      "seo_description": "Live near Kenai Eagle Rock Boat Launch at Bay Arms. Ideal for water lovers, combining comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "kenai-north-beach-vehicle-campgrounds-apartments-bay-arms",
      "search_query": "Kenai North Beach Vehicle Campgrounds apartments",
      "category": "Park",
      "h1_title": "Kenai North Beach Campgrounds Apartments",
      "h2_subtitle": "Discover Bay Arms, situated near Kenai North Beach Vehicle Campgrounds. Ideal for those who love the outdoors and seek convenient living.",
      "page_copy": "Explore life at Bay Arms, the perfect choice for apartments near Kenai North Beach Vehicle Campgrounds. Our community is designed for outdoor enthusiasts who value proximity to the scenic beaches and the convenience of modern living.\n\nBay Arms offers easy access to the beautiful Kenai North Beach, so you can enjoy the great outdoors whenever the mood strikes, while still benefiting from amenities such as on-site maintenance, a laundry room, and bike storage. Choose Bay Arms for a lively and connected lifestyle that embraces the natural beauty of Kenai.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kenai North Beach Campgrounds Apts - Bay Arms",
      "seo_description": "Experience outdoor living at Bay Arms, near Kenai North Beach Campgrounds. Enjoy convenient living for beach and nature lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167173",
      "source": "generator",
      "page_item_url": "bay-arms-kenai-cunningham-park",
      "search_query": "Bay Arms Kenai Cunningham Park",
      "category": "Park",
      "h1_title": "Bay Arms Near Kenai Cunningham Park",
      "h2_subtitle": "Enjoy the tranquility of Bay Arms, located near Kenai's Cunningham Park. Perfect for enjoying nature and comfort.",
      "page_copy": "Bay Arms apartments offer a peaceful retreat just moments away from Kenai's Cunningham Park. This prime location ensures residents can easily access the natural beauty and recreational activities Cunningham Park provides, making it ideal for outdoor enthusiasts.\n\nAt Bay Arms, you can enjoy amenities like bike storage, a convenient laundry room, and attentive on-site management. With the lush surroundings of Cunningham Park nearby, residents experience the perfect fusion of nature and modern comfort right at their doorsteps.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bay Arms Apts Near Cunningham Park - Kenai",
      "seo_description": "Live near Kenai's Cunningham Park at Bay Arms—where nature meets comfort with full amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309438083"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085037"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PKTRL9SM"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/360c8bf7-61b1-48bd-be31-8384db804baf/app.js?property=360c8bf7-61b1-48bd-be31-8384db804baf&propertyName=Bay+Arms&channelUuid=c24901af-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47573318947"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjBHeXNtSG9ScS9RT1Nyck1UU1ZhQnc9PSIsInZhbHVlIjoiYmZ6VCt0ODQ0aC9CRko3VDRwaEhSUT09IiwibWFjIjoiYTA2NzE0MjY1YjM3NzMxZjExOWIwNTMyMzhlZDMyNWJhNDhjNjFkN2ZlYmQzOWVhMGU4ZDlkMjBmMGI4YjNlYiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309438083",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085037",
  "custom_google_gtm_id": "GTM-PKTRL9SM",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/360c8bf7-61b1-48bd-be31-8384db804baf/app.js?property=360c8bf7-61b1-48bd-be31-8384db804baf&propertyName=Bay+Arms&channelUuid=c24901af-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47573318947",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjBHeXNtSG9ScS9RT1Nyck1UU1ZhQnc9PSIsInZhbHVlIjoiYmZ6VCt0ODQ0aC9CRko3VDRwaEhSUT09IiwibWFjIjoiYTA2NzE0MjY1YjM3NzMxZjExOWIwNTMyMzhlZDMyNWJhNDhjNjFkN2ZlYmQzOWVhMGU4ZDlkMjBmMGI4YjNlYiJ9",
  "custom_audioeye_site_id": "20c01044-7a88-4519-ae94-486fb8d53cf2",
  "custom_audioeye_site_hash": "167f2afa00ed9448e557be763f0871e4"
};

export const generatedAt = '2026-11-04T01:10:51.883Z';
